import React from "react";
import Loading from "../Loading/Loading";

const variantStyle = {
  "black-primary": {
    base: "text-[#FFF] bg-primaryColor hover:bg-primaryAccent cursor-pointer",
    disabled: "bg-[#EAEAEA] text-[#666666] cursor-not-allowed",
    loadingColor: "#666666",
    loadingBgColor: "#8e8e8e3c",
  },
  "red-primary":{
    base: "text-[#FFF] bg-[#EF4444] cursor-pointer",
    disabled: "bg-[#EAEAEA] text-[#666666] cursor-not-allowed",
    loadingColor: "#FFF",
    loadingBgColor: "#8e8e8e3c",
  }
};

export default function CustomButton({
  title = "",
  icon = null,
  type = "button",
  className = "",
  disabled = false,
  onClick = () => {},
  variant = "black-primary",
  loading = false,
}) {
  const variantStyles = variantStyle[variant] || variantStyle["black-primary"];
  const appliedVariantClasses = disabled
    ? variantStyles.disabled
    : variantStyles.base;
  const loadingColor = variantStyles.loadingColor || "#9A9A9A";
  const loadingBgColor = variantStyles.loadingBgColor || "#8e8e8e3c";

  const buttonClasses = `
    px-4 py-2 text-base font-ursbold rounded flex items-center justify-center gap-3
    ${appliedVariantClasses}
    ${className}
  `;

  return (
    <button
      type={type}
      className={buttonClasses}
      onClick={disabled ? undefined : onClick}
      disabled={disabled}
    >
      {loading && (
        <Loading className="!w-8" size={18} color={loadingColor} bgColor={loadingBgColor} />
      )}
      {icon && <span className="pointer-events-none">{icon}</span>}
      {title}
    </button>
  );
}
